module.exports = {"id":"dp2_5l1q4","text":"Digital Behaviour","instructions":"Emoji use should be adjusted depending on whether communication is formal or informal.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"2.5","questionType":"PickOne","random":false,"options":[{"id":"dp2_5l1q4-a1","text":"True","score":1.8},{"id":"dp2_5l1q4-a2","text":"Not sure","score":0},{"id":"dp2_5l1q4-a3","text":"False","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.5/l1q4.json
// module id = 1070
// module chunks = 41